// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"styles_highlighted__GLIXX"};